'use client';

import { ReactNode } from 'react';
import { SupabaseAuthProvider } from './SupabaseAuthContext';
import AuthLoader from './AuthLoader';
import { SmartGrowthBookProvider } from './SmartGrowthBookProvider';
import { ProcessingStatusProvider } from '@/components/providers/processing-status-provider';

interface AuthProvidersProps {
  children: ReactNode;
}

/**
 * Combined auth providers for simplified implementation
 * Includes SmartGrowthBookProvider that fetches actual subscription data
 * and ProcessingStatusProvider for global video processing status
 */
export default function AuthProviders({ children }: AuthProvidersProps) {
  return (
    <SupabaseAuthProvider>
      <SmartGrowthBookProvider>
        <ProcessingStatusProvider>
          <AuthLoader>{children}</AuthLoader>
        </ProcessingStatusProvider>
      </SmartGrowthBookProvider>
    </SupabaseAuthProvider>
  );
}